var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect2, _rect3, _rect4, _path22, _rect5, _rect6, _rect7, _path23, _path24, _path25, _path26, _path27, _path28;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoNoti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 34,
    viewBox: "0 0 71 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6705 12.3092C9.88315 11.8405 8.88384 11.7498 8.05107 11.7498C4.99257 11.7498 2.82739 13.8819 2.82739 16.9818C2.82739 20.1724 5.08342 22.1987 8.05107 22.1987C8.85355 22.1987 9.91343 22.0928 10.6856 21.5938V19.6885C10.0346 20.1724 9.09581 20.4446 8.23277 20.4446C6.24928 20.4446 4.87144 19.129 4.87144 16.9818C4.87144 14.8194 6.32499 13.5038 8.12678 13.5038C9.15638 13.5038 9.80744 13.6702 10.6705 14.1692V12.3092Z",
    fill: "#39A887"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5112 18.2066L14.6475 17.7681C15.8133 14.0633 15.9496 13.3073 15.9496 13.3073C15.9496 13.3073 16.101 14.0633 17.2517 17.753L17.388 18.2066H14.5112ZM18.5993 22.0777H20.6585L17.2063 11.8858H14.7383L11.2861 22.0777H13.2848L14.0115 19.7641H17.8725L18.5993 22.0777Z",
    fill: "#39A887"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2617 12.3092C26.5047 11.9463 25.5811 11.8102 24.7786 11.8102C22.6588 11.8102 21.2658 12.9444 21.2658 14.6833C21.2658 16.4072 22.568 17.0876 23.749 17.632C24.8543 18.131 25.7325 18.4637 25.7325 19.2802C25.7325 20.0666 25.0965 20.5353 24.1881 20.5353C23.219 20.5353 22.2197 20.2329 21.3416 19.5978V21.5485C22.0835 21.9719 23.1736 22.1987 24.2032 22.1987C26.2927 22.1987 27.7462 21.0495 27.7462 19.2198C27.7462 17.3901 26.3381 16.7096 25.0511 16.1501C24.0972 15.7267 23.325 15.3335 23.325 14.6077C23.325 13.9575 23.8701 13.4736 24.8391 13.4736C25.6719 13.4736 26.5804 13.7458 27.2617 14.1541V12.3092Z",
    fill: "#39A887"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4689 18.2066L31.6052 17.7681C32.771 14.0633 32.9073 13.3073 32.9073 13.3073C32.9073 13.3073 33.0587 14.0633 34.2094 17.753L34.3457 18.2066H31.4689ZM35.557 22.0777H37.6162L34.164 11.8858H31.696L28.2438 22.0777H30.2425L30.9692 19.7641H34.8302L35.557 22.0777Z",
    fill: "#39A887"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04044 25.3276V24.5366H0V33.8892H0.870494V29.6847H4.54904V28.8937H0.870494V25.3276H5.04044Z",
    fill: "#39A887"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3695 33.8892H7.24V24.5366H6.3695V33.8892Z",
    fill: "#39A887"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06112 33.8892H9.93162V29.9345C9.93162 27.0482 9.90354 25.5496 9.90354 25.5496C9.90354 25.5496 10.8162 27.0621 12.5852 29.9622L14.9861 33.8892H16.1795V24.5366H15.309V28.5052C15.309 31.4331 15.3371 32.8762 15.3371 32.8762C15.3371 32.8762 14.4666 31.4331 12.6695 28.4913L10.2545 24.5366H9.06112V33.8892Z",
    fill: "#39A887"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4548 30.5311L19.6654 29.9483C21.1256 25.7994 21.3081 25.2582 21.3081 25.2582C21.3081 25.2582 21.4766 25.7994 22.9087 29.9345L23.1193 30.5311H19.4548ZM24.2706 33.8892H25.2113L21.9399 24.5366H20.6763L17.3347 33.8892H18.2754L19.188 31.2943H23.372L24.2706 33.8892Z",
    fill: "#39A887"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3627 33.8892H27.2332V29.9345C27.2332 27.0482 27.2051 25.5496 27.2051 25.5496C27.2051 25.5496 28.1177 27.0621 29.8868 29.9622L32.2876 33.8892H33.4811V24.5366H32.6106V28.5052C32.6106 31.4331 32.6386 32.8762 32.6386 32.8762C32.6386 32.8762 31.7681 31.4331 29.971 28.4913L27.5561 24.5366H26.3627V33.8892Z",
    fill: "#39A887"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9231 24.9113C41.2632 24.5783 40.5472 24.4117 39.5363 24.4117C36.9108 24.4117 34.8047 26.2989 34.8047 29.1574C34.8047 32.224 36.7704 34.0002 39.5925 34.0002C40.491 34.0002 41.3896 33.792 41.9512 33.4035V32.4599C41.4177 32.8762 40.5612 33.1815 39.6346 33.1815C37.2758 33.1815 35.7033 31.6135 35.7033 29.1574C35.7033 26.7846 37.3741 25.2304 39.5082 25.2304C40.7438 25.2304 41.2211 25.4525 41.9231 25.8132V24.9113Z",
    fill: "#39A887"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1997 33.8892H44.0701V24.5366H43.1997V33.8892Z",
    fill: "#39A887"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4217 30.5311L47.6323 29.9483C49.0924 25.7994 49.275 25.2582 49.275 25.2582C49.275 25.2582 49.4435 25.7994 50.8756 29.9345L51.0862 30.5311H47.4217ZM52.2375 33.8892H53.1782L49.9068 24.5366H48.6432L45.3016 33.8892H46.2423L47.1549 31.2943H51.3389L52.2375 33.8892Z",
    fill: "#39A887"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2 33.0982V25.3276H57.0252C59.3278 25.3276 60.8582 27.076 60.8582 29.1574C60.8582 31.1417 59.7631 33.0982 57.0954 33.0982H55.2ZM54.3295 24.5366V33.8892H57.0954C60.2685 33.8892 61.7708 31.5857 61.7708 29.1574C61.7708 26.3822 59.7771 24.5366 57.0252 24.5366H54.3295Z",
    fill: "#39A887"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5587 30.5311L64.7693 29.9483C66.2294 25.7994 66.412 25.2582 66.412 25.2582C66.412 25.2582 66.5805 25.7994 68.0126 29.9345L68.2232 30.5311H64.5587ZM69.3745 33.8892H70.3152L67.0438 24.5366H65.7802L62.4386 33.8892H63.3793L64.2919 31.2943H68.4759L69.3745 33.8892Z",
    fill: "#39A887"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.8279,
    y: 19.7991,
    width: 30.4863,
    height: 1.79331,
    rx: 0.896655,
    fill: "#39A887"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3224 12.9249C41.6525 12.9249 41.9202 13.1926 41.9202 13.5227L41.9202 19.5004L40.7246 19.5004L40.7246 13.5227C40.7246 13.1926 40.9923 12.9249 41.3224 12.9249Z",
    fill: "#39A887"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4031 14.4193C47.7237 14.4193 48.7942 15.4898 48.7942 16.8104L48.7942 19.5004L44.012 19.5004L44.012 16.8104C44.012 15.4898 45.0826 14.4193 46.4031 14.4193Z",
    fill: "#39A887"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5195 14.4193C56.4273 14.4193 57.1633 15.1553 57.1633 16.0632L57.1633 19.5004L53.8756 19.5004L53.8756 16.0632C53.8756 15.1553 54.6116 14.4193 55.5195 14.4193Z",
    fill: "#39A887"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3145 17.707L70.3145 19.5003L63.739 19.5003L63.739 17.707C64.3846 18.1377 64.8628 18.1377 65.2932 17.707C65.4059 17.5606 65.5161 17.441 65.6237 17.3484L66.6445 17.3484C66.7346 17.441 66.8222 17.5606 66.9072 17.707C67.5528 18.5041 68.0907 18.5041 68.5211 17.707C68.8613 17.2441 69.5787 17.2441 70.3145 17.707Z",
    fill: "#39A887"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6445 17.3484L65.6237 17.3484C65.9942 17.0296 66.3344 17.0296 66.6445 17.3484Z",
    fill: "#39A887"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3145 19.5003L70.3145 17.707C69.5787 17.2441 68.8613 17.2441 68.5211 17.707C68.0907 18.5041 67.5528 18.5041 66.9072 17.707C66.8222 17.5606 66.7346 17.441 66.6445 17.3484L65.6237 17.3484C65.5161 17.441 65.4059 17.5606 65.2932 17.707C64.8628 18.1377 64.3846 18.1377 63.739 17.707L63.739 19.5003L70.3145 19.5003Z",
    fill: "#39A887"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3145 19.5003L70.3145 17.707C69.5787 17.2441 68.8613 17.2441 68.5211 17.707C68.0907 18.5041 67.5528 18.5041 66.9072 17.707C66.8222 17.5606 66.7346 17.441 66.6445 17.3484L65.6237 17.3484C65.5161 17.441 65.4059 17.5606 65.2932 17.707C64.8628 18.1377 64.3846 18.1377 63.739 17.707L63.739 19.5003L70.3145 19.5003Z",
    fill: "#39A887"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57.1633,
    y: 9.63708,
    width: 3.28774,
    height: 3.28774,
    rx: 1.64387,
    transform: "rotate(90 57.1633 9.63708)",
    fill: "#39A887"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62.2441,
    y: 9.63708,
    width: 3.28774,
    height: 3.28774,
    rx: 1.64387,
    transform: "rotate(90 62.2441 9.63708)",
    fill: "#39A887"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62.2441,
    y: 14.7183,
    width: 3.28774,
    height: 3.28774,
    rx: 1.64387,
    transform: "rotate(90 62.2441 14.7183)",
    fill: "#39A887"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M51.484 3.65955C51.8142 3.65955 52.0818 3.92718 52.0818 4.25732L52.0818 19.5005L50.8862 19.5005L50.8862 4.25732C50.8862 3.92718 51.1539 3.65955 51.484 3.65955Z",
    fill: "#39A887"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 51.949,
    y: 6.62866,
    width: 13.5675,
    height: 1.43166,
    rx: 0.71583,
    transform: "rotate(145.213 51.949 6.62866)",
    fill: "#39A887"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 57.1174,
    y: 1.17578,
    width: 7.75114,
    height: 1.43166,
    rx: 0.71583,
    transform: "rotate(145.213 57.1174 1.17578)",
    fill: "#39A887"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 67.1238,
    y: 9.76733,
    width: 14.5808,
    height: 1.43236,
    rx: 0.716182,
    transform: "rotate(-144.347 67.1238 9.76733)",
    fill: "#39A887"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.13 7.84375C66.4602 7.84375 66.7278 8.11138 66.7278 8.44152L66.7278 14.4192L65.5322 14.4192L65.5322 8.44152C65.5322 8.11138 65.7999 7.84375 66.13 7.84375Z",
    fill: "#39A887"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0708 9.6602H18.5609L18.7111 7.56622C18.806 6.24865 18.8771 5.06442 18.8771 5.06442L20.4582 9.52687H21.0353L21.7705 7.56622C22.2369 6.31924 22.7112 5.00952 22.7112 5.00952C22.7112 5.00952 22.814 6.3114 22.9246 7.56622L23.1065 9.6602H23.5966L23.146 4.37427H22.474L21.7467 6.3114C21.2961 7.51132 20.7507 9.00142 20.7507 9.00142C20.7507 9.00142 20.221 7.46426 19.81 6.3114L19.1143 4.37427H18.4423L18.0708 9.6602Z",
    fill: "#39A887"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7685 9.6602H25.2586V4.37427H24.7685V9.6602Z",
    fill: "#39A887"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4839 9.6602H26.9741V7.42505C26.9741 5.79378 26.9583 4.94678 26.9583 4.94678C26.9583 4.94678 27.4721 5.80163 28.4682 7.44073L29.82 9.6602H30.4919V4.37427H30.0018V6.61726C30.0018 8.27205 30.0176 9.08769 30.0176 9.08769C30.0176 9.08769 29.5275 8.27205 28.5156 6.60942L27.1559 4.37427H26.4839V9.6602Z",
    fill: "#39A887"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9155 4.37427V6.74274H32.1645V4.37427H31.6743V9.6602H32.1645V7.18977H34.9155V9.6602H35.4056V4.37427H34.9155Z",
    fill: "#39A887"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4485 7.76228L37.5671 7.43289C38.3892 5.08795 38.492 4.78208 38.492 4.78208C38.492 4.78208 38.5869 5.08795 39.3932 7.42505L39.5118 7.76228H37.4485ZM40.16 9.6602H40.6897L38.8477 4.37427H38.1363L36.2548 9.6602H36.7845L37.2983 8.19363H39.6541L40.16 9.6602Z",
    fill: "#39A887"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoti);
export default __webpack_public_path__ + "static/media/logo-noti.19c41864a6777360961f8422cc46a3c7.svg";
export { ForwardRef as ReactComponent };